import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const editModalExamsSlice = createSlice({
  name: "editModalExams",
  initialState,
  reducers: {
    openModal: (state, action) => {
      const itemId = action.payload;
      state[itemId] = true;
    },
    closeModal: (state, action) => {
      const itemId = action.payload;
      state[itemId] = false;
    },
  },
});

export const { openModal, closeModal } = editModalExamsSlice.actions;

export default editModalExamsSlice.reducer;
